// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "dist/" + ({"51":"generic-promo-banner","400":"multi-product-page","539":"cookie-disclaimer","862":"newsletter-popups"}[chunkId] || chunkId) + ".js";
};